import React from "react";
import { Container, Grid } from '@material-ui/core';
import { HeaderHLPure, PromotionalFooterPure, DialogSystemGLPure, ButtonHLPure, SimpleLoading } from "../../pures";
import ConsultNegotationNegotiators from "./consult-negotiation-negotiators";
import ConsultNegotiationGuestView from "./consult-negotiation-guests";
import ConsultNegotationChangesView from "./consult-negotiation-changes";
import ConsultNegotationPDFView from "./consult-negotiation-pdf";
import "./consult-negotiation.css";

const ConsultNegotationView = (props) => {

    let {
        t,
        history,
        headerTitle,
        isLoadingView,
        showLoadingRequesting,
        toggleLoadingRequesting,
        showCompletedRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        toggleErrorRequesting,
        messageError,
        showNegotiators,
        showGuests,
        showChages,
        changeUrlPDF,
        labelBtnPDF
    } = props

    const handleBack = () => {
        history.goBack()
    }

    if(isLoadingView) return(<SimpleLoading />)
    return(
        <div className="consultNegotiation-wrapper">
            <Container>
                <Grid container spacing={2}>
                    <div className="consultNegotiation-header">
                        <HeaderHLPure title={headerTitle} />
                    </div>
                    <div className="consultNegotiation-body">
                        <div className="consultNegotiation-elements">
                            <div className="consultNegotiation-grids">
                                {
                                    showNegotiators && (
                                        <ConsultNegotationNegotiators
                                            {...props}
                                        />
                                    )
                                }
                                {
                                    showGuests && (
                                        <ConsultNegotiationGuestView 
                                            {...props}
                                        />
                                    )
                                }
                                {
                                    showChages && (
                                        <ConsultNegotationChangesView
                                            {...props}
                                        />
                                    )
                                }
                            </div>
                            <div className="consultNegotiation-pdf">
                                <ConsultNegotationPDFView
                                    {...props}
                                />
                            </div>
                        </div>
                        <div className="consultNegotiation-container-btn">
                            <div className="consultNegotiation-btn-back">
                                <ButtonHLPure 
                                    nameBtn={t("button.return")}
                                    primary={false}
                                    onClickBtn={() => handleBack()}
                                />
                            </div>
                            <ButtonHLPure 
                                nameBtn={`${t("consultNegotiation.btn.show.document")} ${labelBtnPDF}`}
                                primary={false}
                                onClickBtn={() => changeUrlPDF()}
                            />
                        </div>
                    </div>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <PromotionalFooterPure />
                    </Grid>
                    <DialogSystemGLPure
                        showLoadingRequesting={showLoadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}

                        showCompletedRequesting={showCompletedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}

                        showErrorRequesting={showErrorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        messageError={messageError} 
                    />
                </Grid>
            </Container>
        </div>
    )
}

export { ConsultNegotationView as default }